import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="handle-formatter"
// Formats a phone-number-ish value as (XXX) XXX-XXXX. Fields that hold a "handle" (phone OR email)
// are left alone once they start to look like an email (see the @ / letters check in format()).
export default class extends Controller {
  static targets = [ "input" ]

  connect() {
    // Also format on `input` (not just change/keyup): this catches paste and mobile
    // autofill/predictive text, which don't reliably fire keyup. Deletions are skipped so we never
    // re-add a formatting character the user is trying to erase (the keyup path guards Backspace the
    // same way). format() is idempotent, so this coexists with any change/keyup actions in the view.
    if (this.hasInputTarget) {
      this.onInput = (e) => {
        if (e && typeof e.inputType === "string" && e.inputType.startsWith("delete")) return;
        this.format();
      }
      this.inputTarget.addEventListener("input", this.onInput);
    }
  }

  disconnect() {
    if (this.onInput && this.hasInputTarget) {
      this.inputTarget.removeEventListener("input", this.onInput);
    }
  }

  format(e) {
    if (e && e.key === "Backspace") {
      return;
    }
    let inputValue = this.inputTarget.value;
    let phoneNumberPattern = /^\+?\d?[- \.]?\(?(\d{3})\)?\s*[- \.]?\s*(\d{3})\s*[- \.]?\s*(\d{4})$/;

    if (phoneNumberPattern.test(inputValue)) {
      // if it's a full number, format it.
      this.inputTarget.value = inputValue.replace(phoneNumberPattern, "($1) $2-$3");
    } else if (inputValue.indexOf("@") === -1 && !(/[a-zA-Z]/.test(inputValue))) {
      // if it doesn't seem like an email yet, but it's not fully formatted, start formatting it.
      let digitsOnly = inputValue.replace(/\D/g, '');
      let countDigits = digitsOnly.length;

      if (digitsOnly[0] === "1") {
        digitsOnly = digitsOnly.slice(1);
        countDigits = digitsOnly.length;
      }

      if (countDigits == 0) {
        return;
      }

      if (countDigits < 3) {
        this.inputTarget.value = digitsOnly.replace(/(\d{0,2})/, "($1");
      } else if (countDigits < 6) {
        this.inputTarget.value = digitsOnly.replace(/(\d{0,3})(\d{0,3})/, "($1) $2");
      } else {
        this.inputTarget.value = digitsOnly.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, "($1) $2-$3");
      }
    }
  }
}
